import { InitAnchorScrollSpy } from "@omni/components/aem/AnchorScrollSpy/anchorScrollSpy.component";
import { InitBreadcrumb } from "@omni/components/aem/Breadcrumb/breadcrumb.component";
import { InitFeatureList } from "@omni/components/aem/FeatureList/featureList.component";
import { InitInfoBlock } from "@omni/components/aem/InfoBlock/infoBlock.component";
import { InitModal } from "@omni/components/aem/Modal/modal.component";
import { InitNavigation } from "@omni/components/aem/Navigation/navigation.component";
import { InitPageLink } from "@omni/components/aem/PageLink/pageLink.component";

const init = () => {
    InitAnchorScrollSpy();
    InitBreadcrumb();
    InitNavigation();
    InitFeatureList();
    InitInfoBlock();
    InitModal();
    InitPageLink();
};

export { init };
